import React from 'react';

import { Tag } from '@aircall/tractor';
import { TAGS_DARK_COLORS } from '@constants/style.constants';
import { TagsListQuery_getCompany_tags as CallTagProps } from '@generated/TagsListQuery';

export function getForegroundColor(backgroundColor: string) {
  return TAGS_DARK_COLORS.includes(backgroundColor) ? 'base.white' : 'text.base';
}

export const CallTag = React.memo(({ name, color, id }: CallTagProps) => (
  <Tag
    size='small'
    backgroundColor={color}
    color={getForegroundColor(color)}
    data-test={`call-tag-${id}`}
  >
    {name}
  </Tag>
));
